// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var Opaque = /* #__PURE__ */ (function () {
    function Opaque(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Opaque.create = function (value0) {
        return function (value1) {
            return new Opaque(value0, value1);
        };
    };
    return Opaque;
})();
var Exc = function (x) {
    return x;
};
var map_Exc_label = function (label) {
    return function (v) {
        return {
            label: label,
            source: v.source,
            description: v.description
        };
    };
};
var fromOpaque = function (v) {
    return v.value1;
};
var _error = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var lookup = function (dictOrd) {
    var lookup1 = Data_Map_Internal.lookup(dictOrd);
    return function (dictMonadThrow) {
        var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
        var pure = Control_Applicative.pure((dictMonadThrow.Monad0()).Applicative0());
        return function (dictShow) {
            var show = Data_Show.show(dictShow);
            return function (label) {
                return function (x) {
                    return function (m) {
                        var v = lookup1(x)(m);
                        if (v instanceof Data_Maybe.Nothing) {
                            return throwError({
                                label: _error,
                                source: "lookup",
                                description: label + (" not found: " + show(x))
                            });
                        };
                        if (v instanceof Data_Maybe.Just) {
                            return pure(v.value0);
                        };
                        throw new Error("Failed pattern match at Foliage.Common (line 55, column 20 - line 57, column 19): " + [ v.constructor.name ]);
                    };
                };
            };
        };
    };
};
var _compare = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var _apply_rule = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var _Show_Opaque = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return {
        show: function (v) {
            return "<" + (reflectSymbol(v.value0) + ">");
        }
    };
};
var _Show_Exc = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return {
        show: function (v) {
            return "[exc . " + (reflectSymbol(v.label) + ("] " + (v.source + (": " + v.description))));
        }
    };
};
var _Newtype_Exc = {
    Coercible0: function () {
        return undefined;
    }
};
var _Eq_Opaque = {
    eq: function (v) {
        return function (v1) {
            return false;
        };
    }
};
var _Eq_Exc = /* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "source";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "label";
    }
})(Data_Eq.eqProxy))()({
    reflectSymbol: function () {
        return "description";
    }
})(Data_Eq.eqString));
export {
    Exc,
    _apply_rule,
    _compare,
    _error,
    map_Exc_label,
    Opaque,
    fromOpaque,
    lookup,
    _Newtype_Exc,
    _Eq_Exc,
    _Show_Exc,
    _Eq_Opaque,
    _Show_Opaque
};
